/**
 * Module that handles displaying and navigating the steps of the KB creation wizard
 */
define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbWizardStep/kbWizardStepView",
], function (Marionette, Backbone, Messenger, KbWizardStepView) {
  var KbWizardStepModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbWizardStep";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },
    setActiveStep: function (stepNum) {
      this.kbStepModel.set("step", stepNum);
    },
    setAgentAgent: function (showAgentAssist) {
      this.kbStepModel.set("showAgentAssist", showAgentAssist);
    },
    show: function () {
      this.kbStepModel = new Backbone.Model({ step: 1, showAgentAssist: true });
      this.kbStepModel.set("editMode", this.editMode);
      this.view = new KbWizardStepView.kbWizardStepView({ model: this.kbStepModel });
      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:agent:assist:step",
        function (showAgentAssist) {
          this.setAgentAgent(showAgentAssist);
        },
        this,
      );
    },
  });

  return KbWizardStepModule;
});
